export default __webpack_public_path__ + "static/image2-833ace74de02d6627fdf801b7b578618.gif";